import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, onMounted, Ref, ref } from 'vue';
import { useRouter } from 'vue-router/composables';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  ChipContext,
  ChipStatus,
  HeadingDisplay,
  ButtonBoxLaunch,
  BaseText
} from '@warrenbrasil/nebraska-web';
import { Hero } from '@/modules/common/components/Hero';
import { HeadingDisplayLoader } from '@/modules/trade/components/HeadingDisplayLoader';
import { SectionError } from '@/modules/common/components/SectionError';
import { Money } from '@/modules/common/components/Money';

import {
  getIndexPortfolioHero,
  IPortfolioHero
} from '@/modules/wealth/services/portfolio';
import {
  isImpersonate,
  isImpersonatedByIntranet
} from '@/modules/common/services/partner';


export default /*#__PURE__*/_defineComponent({
  __name: 'PortfolioHero',
  setup(__props) {

const router = useRouter();

const portfolioId = inject('portfolioId') as Ref<string>;

const isLoading = ref(false);
const hasError = ref(false);
const portfolioHero = ref<IPortfolioHero | null>(null);

const portfolioImages = computed(() => {
  return {
    full: portfolioHero.value?.image.full,
    regular: portfolioHero.value?.image.regular,
    small: portfolioHero.value?.image.small
  };
});

const heroClass = computed(() => {
  return {
    'portfolio-hero': true,
    'portfolio-hero__inactive': portfolioHero.value?.isInactive
  };
});

const actionMapper: { [key: string]: Function } = {
  INVESTMENT: goToInvestment,
  REDEMPTION: goToWithdraw
};

function goToInvestment() {
  router.push({
    name: 'variableIncomeInvestment',
    params: { id: portfolioId.value }
  });
}

function goToWithdraw() {
  router.push({
    name: 'variableIncomeWithdraw',
    params: { id: portfolioId.value }
  });
}

async function fetchPortfolioHero() {
  isLoading.value = true;
  hasError.value = false;

  try {
    portfolioHero.value = await getIndexPortfolioHero(portfolioId.value);
  } catch (error) {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}

onMounted(() => {
  fetchPortfolioHero();
});

return { __sfc: true,router, portfolioId, isLoading, hasError, portfolioHero, portfolioImages, heroClass, actionMapper, goToInvestment, goToWithdraw, fetchPortfolioHero, NebraskaColors, ChipContext, ChipStatus, HeadingDisplay, ButtonBoxLaunch, BaseText, Hero, HeadingDisplayLoader, SectionError, Money, isImpersonate, isImpersonatedByIntranet }
}

})